import { useCallback } from "react";
import { useSearchParams } from "react-router";

/** `general` = structure settings (address, host share, visibility). */
export type HouseDetailTabId = "devices" | "presences" | "general";

const TAB_PARAM = "tab";

/** Active tab lives in `?tab=` so a house tab can be deep-linked; devices is the default. */
export function useHouseDetailTab(showPresencesTab: boolean) {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get(TAB_PARAM);
  const activeTab: HouseDetailTabId =
    raw === "general" || (raw === "presences" && showPresencesTab)
      ? raw
      : "devices";

  const setActiveTab = useCallback(
    (tab: HouseDetailTabId) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (tab === "devices") next.delete(TAB_PARAM);
          else next.set(TAB_PARAM, tab);
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  return [activeTab, setActiveTab] as const;
}
